'use client';

import React, { useEffect, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

export default function StickyBar() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 0.6) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (dismissed || !visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 sticky-bar-enter">
      <div className="bg-white border-t border-fog-gray shadow-bar px-6 py-4">
        <div className="max-w-5xl mx-auto flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="w-2 h-2 rounded-full bg-signal-blue live-dot shrink-0" />
            <div>
              <p className="text-sm font-semibold text-slate-dark">1,247 remote roles, curated weekly.</p>
              <p className="text-xs text-slate-light hidden md:block">Senior positions at distributed-first companies — delivered to your inbox.</p>
            </div>
          </div>

          <div className="flex items-center gap-3 shrink-0">
            <a
              href="#get-matched"
              className="flex items-center gap-2 bg-signal-blue text-white text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-blue-600 transition-colors"
              onClick={(e) => {
                e?.preventDefault();
                setDismissed(true);
                const el = document.getElementById('get-matched');
                if (el) el?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Get Matched Weekly
              <Icon name="ArrowRightIcon" size={14} />
            </a>
            <button
              onClick={() => setDismissed(true)}
              className="text-slate-light hover:text-slate-dark transition-colors p-1"
              aria-label="Dismiss"
            >
              <Icon name="XMarkIcon" size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}